import type { Wildart } from "@dj/domain/drueckjagd";

/**
 * Reihenfolge der Wildarten in den Auswahlschritten der Kernabläufe (Schuss, Wildsichtung) wie in der Referenz
 * `#s-wildart` (design/werkzeuge/vorschau/ansichten.py): feste Lage, weil sie im Kernablauf Muskelgedächtnis ist.
 */
export const WILDARTEN_IM_ABLAUF: readonly Wildart[] = ["Rehwild", "Schwarzwild", "Rotwild", "Damwild", "Raubwild"];
